import { useField } from 'formik'
import { Target2 } from 'blaze-ui/icons'
import { Field } from './Field'
import { Input } from 'almanac-ui/TextInputField/Input'

export const GoalField = () => {
  const [field, meta, helpers] = useField<string>('goal')

  return (
    <Field icon={Target2} label="Goal">
      <Input
        value={field.value}
        onChange={(e) => helpers.setValue(e.target.value)}
        placeholder="Enter a goal for the campaign"
        isValid={!meta.touched || !meta.error}
        errorMessage={meta.touched && meta.error}
        name="goal"
        isTextarea
      />
    </Field>
  )
}
